import React from "react"
import {
  Box,
  CardContent as MuiCardContent,
  Chip,
  Typography as MuiTypography,
  Radio,
  FormControl,
  FormLabel,
  FormControlLabel,
  RadioGroup,
  TextField,
} from "@material-ui/core"
import * as IconsGallery from "@iconsGallery"
import { FilterList as FilterListIcon } from "@material-ui/icons"
import { SmallButton, useStyles, StyledMenu } from "./styles"
import _ from "lodash"
import CustomDateFilter from "./CustomDateFilter"
import moment from "moment"
export const dateFilterRange = [
  {
    label: "Last 7 Days",
    value: "7",
  },
  {
    label: "Last 30 Days",
    value: "30",
  },
  {
    label: "Last 60 Days",
    value: "60",
  },
  {
    label: "Last 90 Days",
    value: "90",
  },
  {
    label: "Last 1 Year",
    value: "365",
  },
  {
    label: "Last 2 Years",
    value: "730",
  },
  {
    label: "Custom Date",
    value: ``,
  },
]

const DateFilterRangeKit = (props) => {
  const {
    filterOption: defaultfilterOption = [],
    defaultFilterValue = "",
    onUpdate = () => "",
    disabled = false,
    dateType = "1",
  } = props || {}

  const legacyDate = (value) => {
    if (value === "365") {
      return "1 Year"
    } else if (value === "730") {
      return "Last 2 Years"
    } else if (value === "30" || value === "60" || value === "90") {
      return `${value} Days`
    } else {
      return `Custom Date`
    }
  }

  const newDate = (value) => {
    if (value === "365") {
      return dateType ? "Last 1 Year" : "1 Year"
    } else if (value === "730") {
      return "Last 2 Years"
    } else if (
      value === "7" ||
      value === "30" ||
      value === "60" ||
      value === "90"
    ) {
      return `Last ${value} Days`
    } else {
      return `Custom Date`
    }
  }

  const chipConvertValue = dateType === "2" ? newDate : legacyDate

  const [anchorEl1, setAnchorEl1] = React.useState(null)
  const [filterValue, setFilterValue] = React.useState(defaultFilterValue)
  const [filterOption, setFilterOption] = React.useState(defaultfilterOption)
  const [filteredLabel, setFilteredLabel] = React.useState("")
  const [showDatePicker, setShowDatePicker] = React.useState(true)
  const [getStartDateSelectedDate, setStartDateSelectedDate] = React.useState(
    ""
  )
  const [getEndDateSelectedDate, setEndDateSelectedDate] = React.useState("")

  const handleClose = (e) => {
    return
    // setAnchorEl1(null)
  }

  const handleChange = (event, type) => {
    let year = event.target.value.split("_")[0]
    let calender = year
    setFilterValue(event.target.value)
    setFilteredLabel(event.target.value.label)
    console.log("event.target.value", event.target.value)
    onUpdate({ value: event.target.value })
  }

  const handleStartDateChange = (event) => {
    setStartDateSelectedDate(event.target.value)
  }
  const handleEndDateChange = (event) => {
    setEndDateSelectedDate(event.target.value)
  }

  const renderChip = (value) => {
    return (
      <Chip
        label={
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "start",
              alignItems: "start",
              lineHeight: "15px",
              padding: 2,
            }}
          >
            <span style={{ fontWeight: "bold" }}>
              {chipConvertValue(value)}
            </span>
            {value && value.includes("to") && (
              <span>{`${value.replace("to", " to ")}`}</span>
            )}
          </div>
        }
        size="small"
        variant="outlined"
        color="primary"
        style={{
          borderRadius: "30px",
          marginRight: 10,
          color: "var(--primaryColor)",
          border: `1px solid var(--primaryColor)`,
          minWidth: window.innerWidth <= 640 ? "auto" : "130px",
          minHeight: value && value.includes("to") ? 40 : 30,
        }}
      />
    )
  }

  const classes = useStyles()

  return (
    <React.Fragment>
      <Box textAlign="right" className={classes.boxStyle}>
        <SmallButton
          disabled={disabled}
          onClick={(event) => {
            document.body.classList.add("show-menu")
            setAnchorEl1(event.currentTarget)
          }}
        >
          {renderChip(filterValue)}
          <FilterListIcon />
        </SmallButton>
      </Box>
      <StyledMenu
        name={`filter`}
        id="simple-menu1"
        PaperProps={{
          style: {
            transform:
              window.innerWidth <= 640
                ? "translateX(0%) translateY(13%)"
                : "translateX(-20%) translateY(13%)",
            border: 0,
            boxShadow: "1px 1px 10px #b4b4b4",
            padding: "0px 10px",
            minWidth: 350,
            minHeight: 360,
          },
        }}
        anchorEl={anchorEl1}
        open={Boolean(anchorEl1)}
        onClose={handleClose}
      >
        <FormControl
          style={{ background: "", padding: 10, margin: "auto" }}
          component="div"
        >
          <RadioGroup
            name={`filter`}
            aria-label={`filter`}
            key={defaultFilterValue}
            value={filterValue}
            checked={filterValue}
            onChange={(event) => {
              handleChange(event, "filter")
            }}
          >
            {!_.isEmpty(filterOption) &&
              filterOption.map((item, i) => {
                return (
                  <FormControlLabel
                    key={i}
                    value={item.value}
                    control={<Radio style={{ color: "var(--primaryColor)" }} />}
                    label={item.label}
                    onClick={handleClose}
                  />
                )
              })}
          </RadioGroup>
          {filterValue.includes("to") ? (
            <CustomDateFilter
              defaultDate={filterValue}
              onDateChange={(innerProps) => {
                const { value } = innerProps
                setFilterValue(value)
                console.log("innerProps", innerProps)
                onUpdate({ value: value, isType: "click" }) //{value: '2026-06-10to2026-06-17'}
                handleClose()
              }}
            />
          ) : (
            <></>
          )}
        </FormControl>
        <div
          style={{
            position: "absolute",
            top: 10,
            right: 10,
            cursor: "pointer",
          }}
          onClick={() => {
            document.body.classList.remove("show-menu")
            setAnchorEl1(null)
          }}
        >
          <IconsGallery.CloseRoundeds />
        </div>
      </StyledMenu>
    </React.Fragment>
  )
}
export default DateFilterRangeKit
export { DateFilterRangeKit }
